var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitterIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.916504,
    width: 25,
    height: 24.1667,
    rx: 12.0833,
    fill: "#1DA1F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2167 7.58317C20.575 7.87484 19.8833 8.0665 19.1667 8.15817C19.9 7.7165 20.4667 7.0165 20.7333 6.17484C20.0417 6.5915 19.275 6.88317 18.4667 7.04984C17.8083 6.33317 16.8833 5.9165 15.8333 5.9165C13.875 5.9165 12.275 7.5165 12.275 9.4915C12.275 9.77484 12.3083 10.0498 12.3667 10.3082C9.39999 10.1582 6.75833 8.73317 4.99999 6.57484C4.69166 7.09984 4.51666 7.7165 4.51666 8.3665C4.51666 9.60817 5.14166 10.7082 6.10833 11.3332C5.51666 11.3332 4.96666 11.1665 4.48333 10.9165V10.9415C4.48333 12.6748 5.71666 14.1248 7.34999 14.4498C6.82569 14.594 6.27502 14.6139 5.74166 14.5082C5.968 15.2186 6.41127 15.8402 7.00917 16.2856C7.60707 16.731 8.32953 16.9779 9.07499 16.9915C7.81138 17.9919 6.245 18.5327 4.63333 18.5248C4.34999 18.5248 4.06666 18.5082 3.78333 18.4748C5.36666 19.4915 7.24999 20.0832 9.26666 20.0832C15.8333 20.0832 19.4417 14.6332 19.4417 9.90817C19.4417 9.74984 19.4417 9.59984 19.4333 9.4415C20.1333 8.9415 20.7333 8.30817 21.2167 7.58317Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/twitter-icon.9d61d463e1c6c645709aa302459a4ef0.svg";
export { ForwardRef as ReactComponent };